// src/com/trans_plan_result/TransPlanResultGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * TRANS_PLAN_RESULT Apollo Graphql
 * 배차실적 정보
 * Project: NewTOP for cloud
 * 2025-05-26 14:31:40 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const TRANS_PLAN_RESULT_LIST_PART = gql`
fragment TransPlanResultListPart on TransPlanResult {
    planId
    dcTypeCd
    dcCd
    planDate
    planTime
    hocha
    transTypeCd
    arriveId
    storeId
    comId
    storeTypeCd
    vehInfoSeq
    vehPlates
    vehTypeId
    vehTypeName
    loadCount
    basicCharge
    addCharge
    transCharge
    distanceOne
    distanceRound
    dcKeyDptrTime
    dcKeyDptrDist
    dcBcdDptrTime
    dcBcdOutTime
    storeKeyArrTime
    storeKeyArrDist
    dischStartKeyTime
    dischStartKeyDist
    storeKeyDptrTime
    storeKeyDptrDist
    storeBcdArrTime
    storeBcdDptrTime
    reserve1
    reserve2
    tempr1
    tempr2
    tempr3
    memo
    regUser
    regDate
    dcName
    comName
    driverName
    driverMobile
    storeName
    regUserName
}
`;


export const LIST_TRANS_PLAN_RESULT_FOR_RENT = gql`
${TRANS_PLAN_RESULT_LIST_PART}
query ListTransPlanResult {
    transPlanResultListForRent {
        ...TransPlanResultListPart
    }
}
`;

/* extend type Query {
	transPlanResultListForRent: [TransPlanResult]!
}

extend type Mutation {
	transPlanResultRportInOut(transPlanResult: InputTransPlanResultReportInOut!): CommonResponse!
}
*/

export const REPORT_TRANS_PLAN_RESULT_IN_OUT = gql`
mutation ReportTransPlanResultInOut($transPlanResult:InputTransPlanResultReportInOut!) {
	transPlanResultRportInOut(transPlanResult: $transPlanResult) {
		ok
		message
	}
}
`;
